// noinspection JSUnusedGlobalSymbols

import {DomainEvent} from './DomainEvent';
import type {EntityExportRequest} from './EntityExportRequest';

export interface TeamsExportRequest extends EntityExportRequest {
  /** whether only teams with at least one active season shall be exported, defaults to all teams */
  readonly active?: boolean;
  /** optional, the id of the district of which to export the related teams, defaults to all teams */
  readonly districtId?: number;
}

/**
 * <p>This event can be fired to indicate that a service requires (non-seasonal) teams (optionally restricted to a
 * certain district).</p>
 * <p>Another service that is eligible to provide this info will put batches of the requested models into
 * the specified S3 {@link TeamsExportRequest.targetBucket} using the {@link TeamsExportRequest.transactionId} as prefix
 * (sub-folder).</p>
 */
export class TeamsExportRequested extends DomainEvent<TeamsExportRequest> {}
